///////////////////////////////////////////////////////////////////////////////////////
//                          Copyright (c) 2020 - 2025
//                                  RXO Inc.
//                         All Rights Reserved Worldwide
//
//WARNING:  This program (or document) is unpublished, proprietary
//property of RXO Inc. and is to be maintained in strict confidence.
//Unauthorized reproduction, distribution or disclosure of this program
//(or document), or any program (or document) derived from it is
//prohibited by State and Federal law, and by local law outside of the U.S.
///////////////////////////////////////////////////////////////////////////////////////

import { Fragment } from "react";

import InfoIcon from "../icons/InfoIcon";
import CloseIcon from "../icons/CloseIcon";
import FileIcon from "../form-controls/FileIcon";
import FileDropper from "../FileDropper";
import messages from "../../helpers/messages";

export const Attachments = ({
  files,
  setBidState,
  showDragDropArea = true
}) => {
  const handleDrop = selectedFiles => {
    let newFiles = [];
    selectedFiles.forEach(file => {
      newFiles.push({ name: file.path, file: file });
    });
    setBidState("files", newFiles.concat(files));
  };

  const handleRemoveFile = index => {
    const newFiles = files.slice();
    newFiles.splice(index, 1);
    setBidState("files", newFiles);
  };

  return (
    <Fragment>
      {showDragDropArea && (
        <FileDropper handleDrop={handleDrop}>
          <span className="zeta">
            {messages.dropFilesHereToUploadOr.defaultMessage}
          </span>
          <button id="choose-file" className="underline no-focus cursor">
            {messages.chooseFile.defaultMessage}
          </button>
          <div className="tooltip-tp inline-block">
            <InfoIcon
              className="align-top ml-12"
              width="16px"
              height="16px"
              title=""
            />
            <span className="tooltiptext box--rounded-all">
              <p>{messages.recommendedModeDocuments.defaultMessage}</p>
              <p
                className="font-size-11"
                dangerouslySetInnerHTML={{
                  __html:
                    messages.newBidAttachmentIntermodalMessage.defaultMessage
                }}
              />
              <p
                className="font-size-11"
                dangerouslySetInnerHTML={{
                  __html:
                    messages.newBidAttachmentLessThanTruckloadMessage
                      .defaultMessage
                }}
              ></p>
            </span>
          </div>
        </FileDropper>
      )}
      <div className="selected-files pt-12">
        {files.map((file, index) => (
          <div data-testid="selected-file" className="pt-4 pb-4" key={index}>
            <FileIcon
              className="mr-12"
              mimeType={file.file.type}
              width="11px"
              height="14px"
              fileExtension={file.name.split(".").pop()}
            />
            {file.name}
            <span
              data-testid="file-size"
              className="file-size pl-8 pr-8 alert--empty text-left"
            >
              (
              {file.file.size < 1024 * 1024
                ? Math.round(file.file.size / 1024) + "kb"
                : Number((file.file.size / 1024 / 1024).toFixed(2)) + "mb"}
              )
            </span>
            <button
              data-testid="remove-file"
              onClick={() => handleRemoveFile(index)}
            >
              <CloseIcon
                width="12px"
                height="12px"
                title=""
                className="close-icon align-middle"
              />
            </button>
          </div>
        ))}
      </div>
    </Fragment>
  );
};

export default Attachments;
